import { useTranslation } from '@tecma/i18n';
import { useSelector } from 'react-redux';
import { applicationStateSelectors } from 'store/slices/applicationState/selectors';
import { environmentSelectors } from 'store/slices/environment/selector';
import { downloadFromUrl } from 'utils/downloadFromUrl';

export const useFeaturesDownload = (apartmentName: string) => {
  const { t } = useTranslation();
  const environment = useSelector(environmentSelectors.environment);
  const projectInfo = useSelector(applicationStateSelectors.selectProjectInfo);
  const baseUrl = `${environment?.REACT_APP_BUCKET_BASEURL}/initiatives/${encodeURI(projectInfo?.displayName || '')}`;
  const pdfUrl = `${baseUrl}/global/documents/details/${apartmentName}.pdf`;
  const fallbackPdfUrl = `${baseUrl}/global/documents/details/additional-information.pdf`;

  const checkIfPdfExist = async (url: string) => {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  };

  const checkIfShouldShowDownloadFeaturesButton = async (): Promise<boolean> => {
    const pdfExists = !!apartmentName && (await checkIfPdfExist(pdfUrl));
    if (!pdfExists) {
      const fallbackPdfExists = await checkIfPdfExist(fallbackPdfUrl);
      return fallbackPdfExists;
    }
    return pdfExists;
  };

  const onClickSeeAllFeatures = async () => {
    try {
      const pdfExists = await checkIfPdfExist(pdfUrl);
      if (!pdfExists) {
        const fallbackPdfExists = await checkIfPdfExist(fallbackPdfUrl);
        if (!fallbackPdfExists) {
          alert(t('snackbar.error.documents-download-failed.description'));
          return;
        }
        downloadFromUrl(fallbackPdfUrl, `${apartmentName}_details.pdf`);
        return;
      }
      downloadFromUrl(pdfUrl, `${apartmentName}_details.pdf`);
    } catch (error) {
      alert(t('snackbar.error.documents-download-failed.description'));
    }
  };

  return {
    onClickSeeAllFeatures,
    checkIfShouldShowDownloadFeaturesButton,
  };
};
